import { render, staticRenderFns } from "./crudTank.vue?vue&type=template&id=2c900b93&"
import script from "./crudTank.vue?vue&type=script&lang=js&"
export * from "./crudTank.vue?vue&type=script&lang=js&"
import style0 from "./crudTank.vue?vue&type=style&index=0&id=2c900b93&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports